import React from "react";

import ProgressBar from "@ramonak/react-progress-bar";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const ProgressBarComp = ({progressLabel,checkCircleColor,completed,bgColor}) => {
    return (


        // <ProgressBar
        //     // className="pBCompWrapper"
        //     barContainerClassName="pBCompContainer"
        //     completed={60}
        //     maxCompleted={100}
        //     height="7px"
        //     borderRadius="50px"
        //     isLabelVisible={false}
        // />;

        <>
            <span style={{color: "#606060"}}>{progressLabel}</span>
            <CheckCircleRoundedIcon style={{ color: checkCircleColor, float: "right" }}  />
            <ProgressBar
                completed={completed}
                maxCompleted={100}
                bgColor={bgColor}
                baseBgColor="#FFDBE3"
                height="5px"
                borderRadius="50px"
                isLabelVisible={false}
                // margin="10px auto"
            // width="100%"
            // labelAlignment="left"
            // labelColor="#e80909"
            // customLabel=""
            />
        </>
    )
};

export default ProgressBarComp